module.exports = __webpack_public_path__ + "static/img/wechaticon.03ff4bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechaticon.png
// module id = DyZM
// module chunks = 1